import { AppEnv } from '@brightdrop/app-config';

const CONSOLE_ENVS: readonly string[] = [AppEnv.DEV, AppEnv.UAT];

/**
 * Whether this deployment may offer the console language command (dev and UAT only).
 *
 * Read once when the module loads, from the config `appconfig.js` sets before the app starts.
 * The same build is promoted to production, so a later `appConfig.env = 'dev'` typed into the
 * console must not open it there.
 */
export const IS_CONSOLE_ENV: boolean = CONSOLE_ENVS.includes(
  globalThis.appConfig?.env
);
